"use strict";

exports.__esModule = true;
exports["default"] = void 0;

// Converts a color string into a color value from frontend theme
var colorStringToTheme = function colorStringToTheme(theme, colorString) {
  if (colorString.includes("rgb(") || colorString.includes("rgba(")) {
    return colorString;
  }

  var _colorString$match = colorString.match(/([a-zA-Z]*).([\d])/),
      group = _colorString$match[1],
      shade = _colorString$match[2];

  if (group && shade) {
    return theme.colors[group][shade];
  }

  return colorString;
};

var _default = colorStringToTheme;
exports["default"] = _default;